import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

// A named set of global rubrics spanning subjects (e.g. "Standard",
// "Simplified"). A report template section chooses a family, and each
// student gets the family's rubric for the section's subject and their
// current milestone. One family per jurisdiction is the default.
// Proto: reports.RubricFamily.
export default class RubricFamily extends Model {
  declare [Type]: 'reports/rubric-family';

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('number', { defaultValue: 0 })
  declare jurisdiction: EnumValue<typeof Jurisdiction> | 0;

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('boolean', { defaultValue: false })
  declare isDefault: boolean;
}
